import { ApplicationConfig, provideBrowserGlobalErrorListeners, isDevMode, provideZonelessChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { CORE_INTERCEPTORS, provideCore } from '@corelabs/angular/core';
import { provideAccount } from '@corelabs/angular/account';
import { provideMessages } from '@corelabs/angular/messages';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideEffects } from '@ngrx/effects';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';

import { CustomPreset } from './app.primeng';

import { environment } from '@env/environment';

import { appRoutes } from './app.routing';
import { provideMissingTranslationHandler, provideTranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { CustomMissingTranslationHandler, TranslateLoaderStatic } from './i18n';
import { provideImagesStore } from './store/images';
import { provideMediaStore } from './store/media';
import { provideSessionStore } from './store/session';
import { provideUploadStore } from './store/upload';
import { provideFormOptionsStore } from './store/form-options';
import { provideValuesStore } from './store/values';
import { assignmentsStoreProviders } from './store/assignments';

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideZonelessChangeDetection(),
        provideRouter(appRoutes, withComponentInputBinding(), withRouterConfig({ onSameUrlNavigation: 'reload' })),
        provideAnimationsAsync(),
        provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000',
        }),
        provideHttpClient(withInterceptors([...CORE_INTERCEPTORS])),
        providePrimeNG({
            theme: {
                preset: CustomPreset,
                options: {
                    darkModeSelector: false,
                },
            },
        }),
        provideStore(),
        provideStoreDevtools({
            maxAge: 25,
            logOnly: environment.production,
            connectInZone: true,
        }),
        provideEffects(),
        ...provideImagesStore(),
        ...provideMediaStore(),
        provideCore({ serverUrl: environment.serverUrl + 'api/v1/admin/' }),
        provideAccount({ skip: ['logout-error'] }),
        provideMessages({ secondsShown: 5, visibleCount: 2, updateInterval: 100 }),
        ...provideSessionStore(),
        ...provideUploadStore(),
        ...provideFormOptionsStore(),
        ...provideValuesStore(),
        ...assignmentsStoreProviders,
        ConfirmationService,
        MessageService,
        provideTranslateService({
            loader: provideTranslateLoader(TranslateLoaderStatic),
            missingTranslationHandler: provideMissingTranslationHandler(CustomMissingTranslationHandler),
        }),
    ],
};
